angular.module("materials_types")

    .controller("MaterialsTypesEditCtrl", ['$uibModalInstance','LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate','modalService', '$uibModal','id','is_group', 'logService',
        function ($uibModalInstance, LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, id, is_group, logService) {

        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("MATERIAL_TYPES_WRITE");

            $rootScope.title = $filter('translate')('materials_types.title');
            if (is_group == 1) {
                $scope.material_type = { is_group: true, material_type_id: null };
            } else {
                $scope.material_type = { is_group: false, material_type_id: null };
            }

      /*  if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('materials_types.title'), url: "materials_types.list" },
                { title: $filter('translate')('materials_types.title_add')},
            ];
            
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('materials_types.title'), url: "materials_types.list" },
                { title: $filter('translate')('materials_types.title_edit')},
            ];

            Restangular.one('MaterialsTypes', $stateParams.id).get().then(function (result) {
                $scope.material_type = result;
            });
        }    */           
        
        if (angular.isDefined(id) && id != null && id != "") {
            Restangular.one('MaterialsTypes', id).get().then(function (result) {
                $scope.material_type = result;
            });
        }
        if ($scope.material_type.is_group == false) {
            let params = {
                is_group: true
            }
            Restangular.all('MaterialsTypes').getList(params).then(function (results) {
                $scope.selectMaterialsTypes = results;
                var withoutGroup = {
                    material_type_id: 0,
                    name: $filter('translate')('events.tasks.without_group'),
                    is_group: true
                };
                $scope.selectMaterialsTypes.unshift(withoutGroup);
                if (angular.isUndefined($scope.material_type.material_type_id) || $scope.material_type.material_type_id == null) $scope.material_type.material_type_id = $scope.selectMaterialsTypes[0].id;
            });
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

            $scope.saveMaterialType = function () {
                logService.debug($scope.material_type);
            if ($scope.material_type.material_type_id == 0) $scope.eventTask.material_type_id = null;
            if (angular.isDefined($scope.material_type.id)) {
                $scope.material_type.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('materials_types.save_success'));
                        //$state.go("materials_types.list");
                        $uibModalInstance.close();
                    } else {
                        $scope.errorMessage = result.message;
                        $uibModalInstance.close("Error");
                    }
                });
            } else {

                Restangular.all('MaterialsTypes').post($scope.material_type).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('materials_types.edit_success'));
                        //$state.go("materials_types.list");
                        $uibModalInstance.close();
                    } else {
                        $scope.errorMessage = result.message;
                        $uibModalInstance.close("Error");
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('materials_types.button_delete'),
                message: $filter('translate')('materials_types.delete_message') + " " + $scope.material_type.name + "?",
                onAccept: function () {
                    $scope.material_type.remove().then(function () {
                        toastr.success($filter('translate')('materials_types.deleted_success'));
                        $state.go("materials_types.list");
                        $uibModalInstance.close();
                    });
                }
            });
        };        

}])

;

